import { useEffect, useRef } from "react";
import { FormattedMessage as FM } from "react-intl";

import ButtonsGroup from "components/Buttons/ButtonsGroup";
import { XMarkIcon } from "components/Icons";
import { classNames } from "tools/ui";

let baseStyle =
  "!z-0 shadow-lg bg-gray-100 rounded-lg mx-auto my-auto ring-none";
const dialogStyle = "w-full h-2/3 sm:w-2/3 md:w-3/5";

function BasicModal({
  openModal,
  closeModal,
  handleOk = false,
  children,
  title,
  buttons,
  style,
  styleChild = false,
}) {
  const ref = useRef(null);
  // const size_ = size ?? dialogSize;
  const style_ = style ?? dialogStyle;

  useEffect(() => {
    if (openModal.value) {
      ref.current?.showModal();
    } else {
      ref.current?.close();
    }
  }, [openModal.value]);

  function onAccept() {
    if (handleOk) {
      handleOk();
    }
  }

  return (
    <dialog
      id={title}
      className={classNames(baseStyle, style_)}
      ref={ref}
      onCancel={closeModal}
    >
      {title && (
        <div className="flex py-4 px-5 mb-4 justify-between sticky top-0 bg-gray-100">
          <span className="ml-3 text-neutral-500 text-2xl my-auto">
            <FM id={title} key={title} />
          </span>
          <div className="cursor-pointer active:scale-95" onClick={closeModal}>
            <XMarkIcon
              width="32"
              className="fill-current text-neutral-500 hover:text-red-600 active:text-blue-300"
            />
          </div>
        </div>
      )}
      <div
        id="div-modal-children"
        className={classNames(
          "relative px-4 h-full overflow-x-hidden",
          styleChild,
        )}
      >
        {children}
      </div>
      {buttons && (
        <ButtonsGroup
          buttons={buttons}
          onClose={closeModal}
          onAccept={onAccept}
        />
      )}
    </dialog>
  );
}

export default BasicModal;
